import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { Config } from '@luggagehero/shared/environment';

import { WebModule } from './web.module';

if (!Config.isDevelopment) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(WebModule, { applicationProviders: [provideZoneChangeDetection()] })
  .catch((err) => console.log(err));
